module.exports = __webpack_public_path__ + "aa27de8b42fc819266a67aa288978c74.png";